import ServerBaseError from './ServerBaseError';

export default class ServerUnavailableError extends ServerBaseError {
  constructor(message = 'Temporarily unavailable', showErrorPage = false) {
    super(message, showErrorPage);
  }
}
